import React from 'react';
import { connect } from  'react-redux';
import { toString } from 'utils/helpers';
import { Field } from 'redux-form';
import { changeTab } from 'containers/ChannelsPage/actions';
import { getIn } from 'utils/helpers';

import { ColorPickerButton } from 'components/InputField/File'
import Button from 'components/Button';
import H4 from 'components/H4';
import {
  AppPreview,
  PhotoFilterPreview,
  ChannelInputField,
} from './components';
import SwitchField from "components/SwitchField";
import { StyledForm, DisabledTabWrapper, FilterToggleGroupContainer, FieldHead, FormGroupWithoutBorderBottom } from './styledComponents';
import { ToastContainer, toast } from 'react-toastify';
const notify = () => toast("Changes Saved!");
const restrictText = (e) => {
  const { value } = e.target;

  if (value.length === 25) {
    e.preventDefault();
  }
};
const LogoForm = ({
  handleSubmit,
  nextTab,
  submitting,
  pristine,
  backgroundColor,
  openColorPickerModal,
  themeId,
  channelThemes,
  edit,
  isNew,
  themeInstanceId,
  channelThemeInstances,
  goToThemeTab,
  onShrinkChange,
  reRenderFunction
}) => {
  const themeInstanceKey       = themeInstanceId;
  const themeInstance          = isNew? null : channelThemeInstances[themeInstanceKey];
  const themeKeyFromInstance   =
    themeInstance && themeInstance.channel_theme_id;
  const themeKey               = toString(themeId || themeKeyFromInstance);
  const selectedTheme          = channelThemes[themeKey];
  const secondLineEnabled      =
    (!!selectedTheme && !!selectedTheme.second_line_max_size)
    || !!getIn(channelThemes, [themeKeyFromInstance, 'second_line_max_size']);
  const defaultFirstLine       =
    selectedTheme && selectedTheme.default_first_line_text;
  const defaultSecondLine      =
    selectedTheme && selectedTheme.default_second_line_text;

  return (
    !!selectedTheme || !!themeInstance
      ?
        <StyledForm onSubmit={handleSubmit}>
          <ToastContainer />
          <div className='channel-forms__theme-form-wrapper'>
            <AppPreview
              shrink
              onShrinkChange={onShrinkChange}
              firstLineFieldName='first_line_font_shrink'
              secondLineFieldName='second_line_font_shrink'
              selectedTheme={selectedTheme}
              themeInstance={themeInstance}
              backgroundColor={backgroundColor}
              keydownIsActive
            />
            <PhotoFilterPreview
              small

              selectedTheme={selectedTheme}
              themeInstance={themeInstance}
            />
            <div className='channel-forms__theme-fields'>
              <Field
                name='first_line_text'
                type='text'
                component={ChannelInputField}
                label='Logo Line 1'
                placeholder={defaultFirstLine}
                onChange={restrictText}
              />
              { secondLineEnabled && (
                  <Field
                    name='second_line_text'
                    type='text'
                    component={ChannelInputField}
                    label='Logo Line 2'
                    placeholder={defaultSecondLine}
                    onChange={restrictText}
                  />
                )
              }
              <Field
                name="app_background_color"
                component={ColorPickerButton}
                label='Background'
                buttonText={backgroundColor}
                onClick={openColorPickerModal}
                backgroundColor={backgroundColor}
              />
          <FilterToggleGroupContainer>
            <FormGroupWithoutBorderBottom>
              <FieldHead>
                <div>
                  <strong>Filter Graphics</strong>
                </div>
                <div style={{ width: '100%', margin: '0 auto 1em auto', padding: "0 1em 0 1em" }}>
                  <Field
                    name="with_photo_filter"
                    component={SwitchField}
                    baseSwitch
                    label="Photo filter enabled "
                  />
                </div>
              </FieldHead>
            </FormGroupWithoutBorderBottom>
          </FilterToggleGroupContainer>
            </div>
          </div>
          <div className='channel-forms__group'>
            {edit ?
              (<Button type='submit' onClick={notify} disabled={submitting || pristine}>
                 Save
               </Button>) :
              (<Button  type='button' onClick={() => nextTab()}   disabled={submitting || pristine}>
                Save and Next
              </Button>)
            }
          </div>
        </StyledForm>
      :
        <DisabledTabWrapper>
          <H4>Please select a theme</H4>
          <Button type='button' onClick={goToThemeTab}>
            Back To Themes
          </Button>
        </DisabledTabWrapper>
  );
}

const mapStateToProps = null;

const mapDispatchToProps = (dispatch) => ({
  goToThemeTab: () => dispatch(changeTab(1)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LogoForm);



// WEBPACK FOOTER //
// ./src/containers/ChannelsPage/Forms/LogoForm.js